import dayjs from 'dayjs'
import datas from '@/assets/associations-villes.json'

type Testimonial = {
  organisation_name: string
  organisation_link: string
  organisation_logo: string | null
  first_name: string
  content: string
}

type PageInfo = {
  name: string
  readable_name: string
  slug: string
  title: string
  subtitle: string
  coordinates: {
    latitude: number
    longitude: number
  }
  hero_image_srcset: string | null
  zips: string[]
  department: string
  region: string
  engagment_subtitle: string
  engagment_paragraphs: string[]
  testimonials: Testimonial[]
}

export const useAssociationsVille = (name: string) => {
  // const { $filters } = useNuxtApp()

  const page = datas.find((page: PageInfo) => page.slug.toLowerCase() === name.toLowerCase())

  const heroPictureSrcSet = computed(() => {
    return page?.hero_image_srcset ?? require('@/assets/hero-placeholder.jpg')
  })

  const aroundLatLng = computed(() => {
    return `${page?.coordinates.latitude},${page?.coordinates.longitude}`
  })

  const queryStringParameters = computed(() => {
    const params = {
      city: page?.name ?? '',
      aroundLatLng: aroundLatLng.value,
      statut_juridique: 'Association',
      places_left: '>=|1',
    }
    return new URLSearchParams(params).toString()
  })

  return {
    page,
    heroPictureSrcSet,
    aroundLatLng,
    queryStringParameters,
  }
}
